var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"unitPopup",class:{ 'm-unit-info': true, 'm-unit-info--frame': _vm.frame, 'm-unit-info--black-frame-on-hover': _vm.blackFrameOnHover, 'm-unit-info--hidden':!_vm.isActive }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }